module.exports = __webpack_public_path__ + "1bd29f3d4f0f371366affebe23715975.msgpack";


/*****************
 ** WEBPACK FOOTER
 ** ./~/file-loader!./src/game/models/sprout.msgpack
 ** module id = 597
 ** module chunks = 0
 **/